import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CorteService } from 'src/app/services/corte.service';
import { FormatoData, FormatoService } from 'src/app/services/formato.service';

@Component({
  selector: 'app-formato-incidencia',
  templateUrl: './formato-incidencia.component.html',
  styleUrls: ['./formato-incidencia.component.scss']
})
export class FormatoIncidenciaComponent implements OnInit {

  incidencias: any[];
  data$: Observable<FormatoData>;
  finalise = new Subject();

  constructor(
    private formatoService: FormatoService,
    private toastr: ToastrService,
    private corteService: CorteService
  ) {
    this.data$ = formatoService.obtenerData;
  }

  ngOnInit(): void {

    this.data$.pipe(takeUntil(this.finalise)).subscribe( data => {
      if ( data.tipo === 2 ) {
        this.corteService.getCorteIncidencia( data.id_corte_usuario ).subscribe( incidencias => {
          this.incidencias = incidencias;
          console.log( this.incidencias );
        });
      }
      this.finalise.next();
      this.finalise.complete();
    });

  }

}
